import React, { useEffect, useState } from "react";
import { addNewDelivery, getDeliveries, deleteDelivery } from "../../configs/productsConfig";

function AdminDelivery() {

    const [deliveryOption, setDeliveryOption] = useState({
        name: '',
        size: 'XS',
        price: '',
        cod: 0,
        deliveryCode: 0
    });

    const [ newDeliveries, setNewDeliveries ] = useState([]);
    const [ oldDeliveries, setOldDeliveries ] = useState([]);

    const fetchData = async () => {
        try {
            const data = await getDeliveries();
            setOldDeliveries(data);
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    const [visibleDivs, setVisibleDivs] = useState({
        newDeliveryDiv: false,
        oldDeliveryDiv: false,
      });
      
    const openDiv = (id) => {
        setVisibleDivs((prev) => ({
            ...prev,
            [id]: !prev[id],
        }));
    };

    const handleAddDeliveryOption = (e) => {
        e.preventDefault();
        setNewDeliveries((prevData) => ([
            ...prevData,
            { ...deliveryOption }
        ]));
        setDeliveryOption({ name: '', size: 'XS', price: '', cod: 0, deliveryCode: 0 });
    };

    const deleteDeliveryOption = async (idToDelete) => {
        try {
            const res = await deleteDelivery(idToDelete);
        
            if (res.success === true) {
              fetchData();
            }
          } catch (error) {
            console.error("Error delete delivery:", error);
          }
    };
    
    const handleSaveDeliveries = async (savedDelivery) => {
        try {
          const res = await addNewDelivery(savedDelivery);
      
          if (res.success === true) {
            setNewDeliveries([]);
            fetchData();
          }
        } catch (error) {
          console.error("Error saving deliveries:", error);
        }
      };
      

    return (
        <div className='container-lg p-0 py-3 '>

            <h4 className="mb-4">Szállítási opciók kezelése</h4>

            <button className='btn' onClick={()=>openDiv('newDeliveryDiv')}>Új szállítás hozzáadása <span>&#11167;</span></button>
            <div className={`${visibleDivs.newDeliveryDiv === true ? '' : 'd-none'} d-flex flex-column align-items-center`}>
                <form className='d-flex flex-column col-md-7 col-11'>

                    <div className="form-floating mb-3">

                        <input type="text" className={`form-control`} id="deliveryName" placeholder="" value={deliveryOption.name} onChange={(e) => setDeliveryOption((prevData) => ({
                            ...prevData,
                            name: e.target.value
                        }))} />

                        <label htmlFor="deliveryName">Szállítási opció megnevezése</label>

                    </div>

                    <div>
                        <h6>Csomag mérete</h6>
                        <div className="mb-3 d-flex flex-row justify-content-around">
                            <div>
                                <input type="radio" id="sizeXS" value='XS' checked={deliveryOption.size === "XS"} onChange={(e) => setDeliveryOption((prevData) => ({
                                    ...prevData,
                                    size: e.target.value
                                }))} />
                                <label htmlFor="sizeXS" className="ms-1">XS</label>
                            </div>

                            <div>
                                <input type="radio" id="sizeS" value='S' checked={deliveryOption.size === "S"} onChange={(e) => setDeliveryOption((prevData) => ({
                                    ...prevData,
                                    size: e.target.value
                                }))} />
                                <label htmlFor="sizeS" className="ms-1">S</label>
                            </div>

                            <div>
                                <input type="radio" id="sizeM" value='M' checked={deliveryOption.size === 'M'} onChange={(e) => setDeliveryOption((prevData) => ({
                                    ...prevData,
                                    size: e.target.value
                                }))} />
                                <label htmlFor="sizeM" className="ms-1">M</label>
                            </div>

                            <div>
                                <input type="radio" id="sizeL" value='L' checked={deliveryOption.size === 'L'} onChange={(e) => setDeliveryOption((prevData) => ({
                                    ...prevData,
                                    size: e.target.value
                                }))} />
                                <label htmlFor="sizeL" className="ms-1">L</label>
                            </div>

                        </div>
                    </div>

                    <div className="form-check mb-2">
                    <label htmlFor="cod" className="form-check-label">Utánvét</label>
                        <input id="cod"  className="form-check-input" type="checkbox" value="" onChange={(e) => setDeliveryOption((prevData) => ({
                            ...prevData,
                            cod: e.target.checked ? 1 : 0
                        }))} />         
                    </div>
                    

                    <div className="mb-3 d-flex flex-row">
                    <div className="form-floating me-2">

                        <input type="number" className={`form-control `} id="price" placeholder="" value={deliveryOption.price} onChange={(e) => setDeliveryOption((prevData) => ({
                            ...prevData,
                            price: e.target.value
                        }))} />

                        <label htmlFor="price">Ár</label>

                    </div>

                    <div className="form-floating">

                        <input type="number" className={`form-control `} id="deliveryCode" placeholder="" value={deliveryOption.deliveryCode} onChange={(e) => setDeliveryOption((prevData) => ({
                            ...prevData,
                            deliveryCode: e.target.value
                        }))} />

                        <label htmlFor="price">Szállítási kód</label>

                    </div>
                    </div>
                        <p>Ha bármilyen házhozszállítás szállítási kód 0, ha Foxpost csomagautomata 1.</p>
                    <button className="btn btn-home-primary col-4 mx-auto mb-4" onClick={(e) => handleAddDeliveryOption(e)}>Opció létrehozása</button>

                </form>
              
                <div className={`container-lg col-md-7 ${newDeliveries.length === 0 ? 'd-none' : ''}`}>
                    <table className="table table-striped">
                        <thead>
                            <tr>
                                <th></th>
                                <th>Opció</th>
                                <th>Csomag mérete</th>
                                <th>Ár</th>
                                <th>Szállítási kód</th>
                            </tr>
                        </thead>
                        <tbody className="text-center">
                            {newDeliveries.map((delivery, index) => (
                                <tr key={index}>
                                    <td scope="row">
                                        <button className="btn" onClick={() => deleteDeliveryOption(newDeliveries, setNewDeliveries, index)}>X</button>
                                    </td>
                                    <td>{delivery.name}</td>
                                    <td>"{delivery.size}"</td>
                                    <td>{delivery.price} Ft</td>
                                    <td>{delivery.deliveryCode}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                    
                <div className={`d-flex justify-content-center col-12 ${newDeliveries.length === 0 ? 'd-none' : ''}`}>
                    <button className="btn btn-home-primary col-2" onClick={() => handleSaveDeliveries(newDeliveries)}>Mentés</button>
                </div>

                <hr className="col-11 mx-auto"></hr>
            </div>
            
            <button className='btn' onClick={()=>openDiv('oldDeliveryDiv')}>Szállítások kezelése <span>&#11167;</span></button>
            <div className={visibleDivs.oldDeliveryDiv === true ? '' : 'd-none'}>
                <div className="container-lg col-md-7">
                        <table className="table table-striped">
                            <thead>
                                <tr>
                                    <th></th>
                                    <th>Opció</th>
                                    <th>Csomag mérete</th>
                                    <th>Ár</th>
                                    <th>Szállítási kód</th>
                                </tr>
                            </thead>
                            <tbody className="text-center">
                                {oldDeliveries.map((delivery, index) => (
                                    <tr key={index}>
                                        <td scope="row">
                                            <button className="btn" onClick={() => deleteDeliveryOption(delivery.id)}>X</button>
                                        </td>
                                        <td>{delivery.name}</td>
                                        <td>"{delivery.size}"</td>
                                        <td>{delivery.price} Ft</td>
                                        <td>{delivery.deliveryCode}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                </div>

        </div>
    );
};

export default AdminDelivery;